import { colors, darkThemeSelector, styled } from '../../../stitches.config';
import { Body } from '../../../text/Body';
import { Small } from '../../../text/Small';

const FieldLabel = styled('label', {
  color: colors.headingNeutralLight,
  fontWeight: '$bold',

  [darkThemeSelector]: {
    color: colors.headingNeutralDark,
  },

  variants: {
    clickable: {
      true: {
        cursor: 'pointer',
      },
      false: {},
    },
    internal: {
      true: {
        color: colors.internalHeadingLight,

        [darkThemeSelector]: {
          color: colors.internalHeadingDark,
        },
      },
      false: {},
    },
  },
});

const FieldDescription = styled(Small, {
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,

        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
    },
  },
});

const FieldElements = styled('div', {
  paddingTop: '$8',
});

/** Primary composites */
export const PrimaryFieldLabel = styled(FieldLabel, Body);
PrimaryFieldLabel.displayName = 'PrimaryFieldLabel';
export const PrimaryFieldDescription = styled(FieldDescription);
PrimaryFieldDescription.displayName = 'PrimaryFieldDescription';
export const PrimaryFieldElements = styled(FieldElements);
PrimaryFieldElements.displayName = 'PrimaryFieldElements';

/** Secondary composites */
export const SecondaryFieldLabel = styled(FieldLabel, Small);
SecondaryFieldLabel.displayName = 'SecondaryFieldLabel';
export const SecondaryFieldDescription = styled(FieldDescription);
SecondaryFieldDescription.displayName = 'SecondaryFieldDescription';
export const SecondaryFieldElements = styled(FieldElements);
SecondaryFieldElements.displayName = 'SecondaryFieldElements';
